import script from "./ReviewProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewProducts.vue?vue&type=script&setup=true&lang=js"

import "./ReviewProducts.vue?vue&type=style&index=0&id=6b217390&lang=scss"

const __exports__ = script;

export default __exports__